/**
 * Created by razial on 09.01.2021
 */

cleverapps.GridLayout = cc.Node.extend({
    ctor: function (items, options) {
        this._super();

        this.items = items.slice();

        this.setAnchorPoint(0.5, 0.5);
        this.prepareOptions(options);

        if (options.fitToBox && this.options.columns === "auto") {
            this.autoColumns();
        }

        this.reshape();
    },

    autoColumns: function () {
        let maxScale = 0;
        let columns = 1;
        for (let rows = 1; rows <= Math.min(this.items.length, 5); rows++) {
            this.options.columns = Math.ceil(this.items.length / rows);

            this.splitItemsInRows();
            this.calcCellsSize();
            this.calcContentSize();

            const scale = Math.min(this.options.fitToBox.width / this.width, this.options.fitToBox.height / this.height);

            if (scale > maxScale) {
                maxScale = scale;
                columns = this.options.columns;
            }
        }

        this.options.columns = columns;
    },

    prepareOptions: function (options) {
        options = options || {};
        options.padding = options.padding || {};
        options.margin = options.margin || {};
        options.align = options.align || {};
        options.separator = options.separator || {};

        this.options = {
            columns: options.columns || 1,
            reverseRows: options.reverseRows || false,
            margin: {
                x: options.margin.x || 0,
                y: options.margin.y || 0
            },
            padding: {
                left: options.padding.left || options.padding.x || 0,
                right: options.padding.right || options.padding.x || 0,
                top: options.padding.top || options.padding.y || 0,
                bottom: options.padding.bottom || options.padding.y || 0
            },
            align: {
                x: options.align.x || cleverapps.GridLayout.ALIGN_CENTER,
                y: options.align.y || cleverapps.GridLayout.ALIGN_CENTER
            },
            cell: options.cell && {
                width: options.cell.width || 0,
                height: options.cell.height || 0
            },
            separator: {
                horizontal: options.separator.horizontal,
                map: options.separator.map
            },
            ascZOrder: options.ascZOrder,
            fitToBox: options.fitToBox,
            centerLastRow: options.centerLastRow || false
        };
    },

    setItems: function (items) {
        this.items = items.slice();

        this.reshape(false);
    },

    calcCellsSize: function () {
        const columnsWidth = this.columnsWidth = [];
        const rowsHeight = this.rowsHeight = [];
        let i, j;

        if (this.options.cell) {
            for (i = 0; i < this.rows.length; ++i) {
                rowsHeight[i] = this.options.cell.height;
            }
            for (i = 0; i < this.options.columns; ++i) {
                columnsWidth[i] = this.options.cell.width;
            }
        } else {
            for (i = 0; i < this.rows.length; ++i) {
                for (j = 0, row = this.rows[i]; j < row.length; ++j) {
                    const child = row[j];
                    columnsWidth[j] = Math.max(Math.abs(child.width * child.scaleX), columnsWidth[j] || 0);
                    rowsHeight[i] = Math.max(Math.abs(child.height * child.scaleY), rowsHeight[i] || 0);
                }
            }
        }
    },

    splitItemsInRows: function () {
        const rows = this.rows = [];
        for (let i = 0; i < this.items.length; i += this.options.columns) {
            rows.push(this.items.slice(i, i + this.options.columns));
        }

        if (!this.options.reverseRows) {
            rows.reverse();
        }
    }, 

    calcContentSize: function () {
        const options = this.options;

        const width = this.columnsWidth.reduce((acc, value) => acc + value + options.margin.x, 0) + options.padding.left + options.padding.right - options.margin.x;

        const height = this.rowsHeight.reduce((acc, value) => acc + value + options.margin.y, 0) + options.padding.bottom + options.padding.top - options.margin.y;

        this.setContentSize(width, height);
    },

    reshape: function (cleanUp) {
        this.removeAllChildren(cleanUp);
        this.splitItemsInRows();
        this.calcCellsSize();
        this.calcContentSize();

        const options = this.options;
        let curX, curY = options.padding.bottom;

        for (let i = 0; i < this.rows.length; ++i) {
            const row = this.rows[i];
            curX = options.padding.left + this.calcRowCenterOffset(row);

            for (let j = 0; j < row.length; ++j) {
                this.insertChild(row[j], curX, curY, i, j);

                if (options.separator.horizontal && j !== row.length - 1) {
                    if (!row[j].skipSeparator) {
                        this.addSeparator(options.separator.horizontal, curX + this.columnsWidth[j], curY, options.margin.x, this.rowsHeight[i]);
                    }
                }
                curX += this.columnsWidth[j] + options.margin.x;
            }

            curY += this.rowsHeight[i] + options.margin.y;
        }
    },

    calcRowCenterOffset: function (row) {
        if (!this.options.centerLastRow || row.length >= this.columnsWidth.length) {
            return 0;
        }

        const margin = this.options.margin.x;
        const rowWidth = this.columnsWidth.slice(0, row.length).reduce((acc, value) => acc + value + margin, 0) - margin;
        const fullWidth = this.columnsWidth.reduce((acc, value) => acc + value + margin, 0) - margin;

        return (fullWidth - rowWidth) / 2;
    },

    insertChild: function (child, curX, curY, row, col) {
        const anchor = {}, position = {};

        switch (this.options.align.x) {
            case cleverapps.GridLayout.ALIGN_START:
                anchor.x = 0;
                position.x = curX;
                break;

            case cleverapps.GridLayout.ALIGN_END:
                anchor.x = 1;
                position.x = curX + this.columnsWidth[col];
                break;

            default:
                anchor.x = 0.5;
                position.x = curX + this.columnsWidth[col] / 2;
                break;
        }

        switch (this.options.align.y) {
            case cleverapps.GridLayout.ALIGN_START:
                anchor.y = 0;
                position.y = curY;
                break;

            case cleverapps.GridLayout.ALIGN_END:
                anchor.y = 1;
                position.y = curY + this.rowsHeight[row];
                break;

            default:
                anchor.y = 0.5;
                position.y = curY + this.rowsHeight[row] / 2;
                break;
        }

        this.addChild(child);
        child.setAnchorPoint(anchor.x, anchor.y);
        child.setAlignment(position.x, position.y);
        if (this.options.ascZOrder) {
            child.setLocalZOrder(this.rows.length - row);
        }
    },

    addSeparator: function (styles, x, y, width, height) {
        const separator = new cc.Sprite(styles.icon || bundles.merge.frames.next_arrow);
        separator.setAnchorPoint(0.5, 0.5);
        separator.setAlignment(
            x + (styles.x ? separator.calculateAxis(styles.x, "x", width) : width / 2),
            y + (styles.y ? separator.calculateAxis(styles.y, "y", height) : height / 2)
        );
        this.addChild(separator);
    }
});
cleverapps.GridLayout.ALIGN_CENTER = 0;
cleverapps.GridLayout.ALIGN_START = 1;
cleverapps.GridLayout.ALIGN_END = 2;
